import FilteredNewsCards from '../../components/organisms/filtered-news-cards/filtered-news-cards';
import { generateDatesASC } from '../../utils/date';
import { usePagination } from '../../hooks/usePagination';
import Pagination from '../../components/atoms/pagination/pagination';
import { PaginationModel } from '../../interface/pagination';
import { useNewsAndEventsFilter } from '../../hooks/useNewsAndEventsFilter';
import { MetaPages } from '../../enums/pages';
import ContainerWithSidebar from '../../components/atoms/container-with-sidebar/container-with-sidebar';
import { NewsAndEventsModel } from '../../interface/news-and-events';
import ArchiveDates from '../../components/molecules/archive-dates/archive-dates';
import SectionTitle from '../../components/atoms/section-title/section-title';
import MarginSpacing from '../../components/atoms/margin-spacing/margin-spacing';
import {
  getNewsAndEventsContent,
  getNewsBannerContent
} from '../../services/news';
import Tabs from '../../components/molecules/tabs/tabs';
import HeaderContainer from '../../components/molecules/header-container/header-container';
import { newsRoutes } from '../../config/routes/pages';
import { ContentType } from '../../types/content';
import {
  NewsAndEventsHeaderEnums,
  NewsAndEventsFilterEnums
} from '../../enums/news';
import TabTitle from '../../components/atoms/tab-title/tab-title';

type IndexProps = {
  newsBannerContent: ContentType;
  newsAndEventsContent: NewsAndEventsModel[];
  pagination: PaginationModel;
};

export function Index(props: IndexProps) {
  const { newsBannerContent, newsAndEventsContent, pagination } = props;
  const { FEATURED_STORIES: FEATURED_STORIES_HEADER } =
    NewsAndEventsHeaderEnums;
  const { FEATURED_STORIES: FEATURED_STORIES_FILTER } =
    NewsAndEventsFilterEnums;

  const yearsPublished = generateDatesASC(newsAndEventsContent);

  const { filteredNewsAndEventsContent, selectedYear, handleClickYear } =
    useNewsAndEventsFilter(newsAndEventsContent, FEATURED_STORIES_FILTER);

  const { currentContent, currentPage, handlePageClick } = usePagination(
    FEATURED_STORIES_FILTER,
    filteredNewsAndEventsContent
  );

  const filteredNewsCards = (
    <FilteredNewsCards
      currentContent={currentContent}
      filteredNewsAndEventsContent={filteredNewsAndEventsContent}
      selectedYear={selectedYear}
    />
  );

  return (
    <>
      <TabTitle page={MetaPages.NEWS_AND_EVENTS} />
      <HeaderContainer {...newsBannerContent} />
      <Tabs tabItems={newsRoutes} />
      <MarginSpacing margin="mb-10 lg:mb-20" />
      <SectionTitle title={FEATURED_STORIES_HEADER} />
      <MarginSpacing margin="mb-10 lg:mb-20" />
      <div className="px-10">
        <ContainerWithSidebar
          featuredContents={
            <ArchiveDates
              dates={yearsPublished}
              selectedYear={selectedYear}
              onClickSelectYear={handleClickYear}
            />
          }
        >
          <div className="space-y-8 mb-5 lg:mb-14">{filteredNewsCards}</div>
          <Pagination
            content={filteredNewsAndEventsContent}
            currentPage={currentPage}
            pageCount={pagination.pageCount}
            pageLimit={pagination.pageSize}
            onPageClick={handlePageClick}
          />
        </ContainerWithSidebar>
      </div>
    </>
  );
}

export async function getStaticProps() {
  const newsBannerContent = await getNewsBannerContent();
  const newsAndEventsContent = await getNewsAndEventsContent(
    NewsAndEventsFilterEnums.FEATURED_STORIES
  );
  const { pagination } = newsAndEventsContent.meta;

  return {
    props: {
      newsBannerContent,
      newsAndEventsContent: newsAndEventsContent.data,
      pagination
    }
  };
}

export default Index;
